import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

// project import
import { LoaderSuspense } from "utils/loader";
import { useSelector } from "react-redux";
import { selectAuth } from "features/auth/authSlice";

const AuthGuard = ({ children }) => {
  const { claims, logged, status, user } = useSelector(selectAuth);

  // console.log({ claims, logged, status, user });
  // return <LoaderSuspense />;

  if (!logged) {
    if (status === "loading") {
      return <LoaderSuspense />;
    } else {
      if (!logged) {
        return <Navigate to="/auth/login" />;
      } else if (claims.length === 0) {
        return <LoaderSuspense />;
      } else if (user.status !== "a") {
        return <Navigate to="/status" />;
      } else {
        return <Navigate to="/403" />;
      }
    }
  }
  return children;

  // console.log(claims)
  // const LoggedAndHasRole = (props) => {
  //   if (status === "loading") {
  //     return <LoaderSuspense />;
  //   } else {
  //     if (!logged) {
  //       return redirect("/auth/login");
  //     } else if (claims.length === 0) {
  //       return <LoaderSuspense />;
  //     } else if (user.status !== "a") {
  //       return redirect("/status");
  //     } else if (claims?.role === "admin" || claims?.role === "agent") {
  //       return <Component {...props} />;
  //     } else {
  //       return redirect("/403");
  //     }
  //   }
  // };
};

AuthGuard.propTypes = {
  children: PropTypes.object.isRequired,
};

export default AuthGuard;
